// B. Local application storage — IndexedDB (§25). Perzistentní úložiště témat
// v prohlížeči, plně offline. Stejné rozhraní jako MemoryBCFRepository.
import { BCFRepository } from "./BCFRepository.js";

export class IndexedDBBCFRepository extends BCFRepository {
  constructor({ dbName = "bcf", store = "topics" } = {}) {
    super();
    this.dbName = dbName; this.store = store; this._db = null;
  }

  async _open() {
    if (this._db) return this._db;
    this._db = await new Promise((res, rej) => {
      const req = indexedDB.open(this.dbName, 1);
      req.onupgradeneeded = () => { const db = req.result; if (!db.objectStoreNames.contains(this.store)) db.createObjectStore(this.store, { keyPath: "id" }); };
      req.onsuccess = () => res(req.result);
      req.onerror = () => rej(req.error);
    });
    return this._db;
  }

  async _tx(mode, fn) {
    const db = await this._open();
    return await new Promise((res, rej) => {
      const tx = db.transaction(this.store, mode);
      const st = tx.objectStore(this.store);
      const out = fn(st);
      tx.oncomplete = () => res(out.result !== undefined ? out.result : out);
      tx.onerror = () => rej(tx.error);
    });
  }

  async getTopics() { return (await this._tx("readonly", (st) => st.getAll())) || []; }
  async getTopic(id) { return (await this._tx("readonly", (st) => st.get(id))) || null; }
  async saveTopic(topic) { await this._tx("readwrite", (st) => st.put(JSON.parse(JSON.stringify(topic)))); }
  async deleteTopic(id) { await this._tx("readwrite", (st) => st.delete(id)); }
  async clear() { await this._tx("readwrite", (st) => st.clear()); }
}
